import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, Typography, App } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { getUserById, changeUserPassword } from '../../services/users';
import ChangePasswordForm from '../../components/ChangePasswordForm/ChangePasswordForm';

const { Title } = Typography;
const { useApp } = App;

const ChangePasswordPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { message } = useApp();

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!id) {
      navigate('/users/all');
      return;
    }

    const loadUser = async () => {
      try {
        setLoading(true);
        const userData = await getUserById(id);
        setUser(userData);
      } catch (err) {
        message.error('No se pudo cargar la información del usuario');
        navigate('/users/all');
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, [id, navigate, message]);

  const handleSubmit = async (values) => {
    if (!id) return;

    setSubmitting(true);
    setError(null);

    try {
      await changeUserPassword(id, values.password);
      setSuccess(true);
      message.success('Contraseña actualizada correctamente');
      navigate('/users/all');

    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        err?.message ||
        'No se pudo cambiar la contraseña. Intenta de nuevo.';
      setError(errorMessage);
      message.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: 24 }}>
        <Card loading={loading} />
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <Button
          type="text"
          icon={<LeftOutlined style={{ fontSize: '24px', strokeWidth: 4 }} />} 
          style={{ 
            padding: 0,
            color: '#BA955E',
            fontSize: '24px',
            fontWeight: '700',
            height: 'auto'
          }}
          onClick={() => navigate('/users/all')}
        />
        <Title level={4} style={{ margin: 0 }}>
          Cambiar contraseña
          {user && ` - ${user.firstName || user.name || user.email}`}
        </Title>
      </div>
      <Card>
        <ChangePasswordForm
          onSubmit={handleSubmit}
          loading={submitting}
          error={error}
          success={success}
          successMessage="La contraseña se actualizó correctamente. Serás redirigido a la lista de usuarios."
          disabled={success}
          title="Cambiar contraseña de usuario"
        />
      </Card>
    </div>
  );
};

export default ChangePasswordPage;

